import { createContext } from "react";
//#region src/contexts/layout.ts
const LayoutContext = createContext(null);
//#endregion
export { LayoutContext };

//# sourceMappingURL=layout.js.map